export const ALERT_TYPES = {
    NORMAL: "primary",
    LIGHT: "secondary",
    OK: "success",
    ERROR: "danger",
    WARN: "warning",
    INFO: "info"
};

export function showAlert(targetId, type = ALERT_TYPES.ERROR, title = "", message) {
    const duration = ((title + " " + message).trim().split(/\s+/).length) * 500 + 1500;

    const alertElement = document.getElementById(targetId);
    if (!alertElement) return;

    if (alertElement.hideTimeout) {
        clearTimeout(alertElement.hideTimeout);
    }

    const hideAlert = () => {
        alertElement.classList.add('alert-hidden');
        alertElement.removeEventListener('click', hideAlert);
    };
    const clickHandler = () => {
        clearTimeout(alertElement.hideTimeout);
        hideAlert();
    };

    alertElement.className = 'alert border-2 p-2 managed-alert';
    alertElement.classList.add(`border-${type}`, `text-${type}`);
    alertElement.innerHTML = `${title ? `<strong>${title}</strong> ` : ''}${message}`;

    alertElement.classList.remove('alert-hidden');

    alertElement.addEventListener('click', hideAlert, { once: true });

    alertElement.hideTimeout = setTimeout(hideAlert, duration);

}